import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import Navbar from "../components/landing/Navbar";
import Hero from "../components/landing/Hero";
import TrustedBy from "../components/landing/TrustedBy";
import Features from "../components/landing/Features";

import Workflow from "../components/landing/Workflow";
import Agents from "../components/landing/Agents";

import DashboardPreview from "../components/landing/DashboardPreview";
import Metrics from "../components/landing/Metrics";
import Testimonials from "../components/landing/Testimonials";
import FAQ from "../components/landing/FAQ";
import Newsletter from "../components/landing/Newsletter";
import ChatWidget from "../components/landing/ChatWidget";
import SignupDialog from "../components/landing/SignupDialog";
import VideoModal from "../components/landing/VideoModal";
import Pricing from "../components/landing/Pricing";

export default function LandingPage() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [signupOpen, setSignupOpen] = useState(false);
  const [authMode, setAuthMode] = useState("signup");
  const [videoOpen, setVideoOpen] = useState(false);

  useEffect(() => {
    if (location.pathname === "/login" && !loading) {
      if (user) {
        navigate("/workspace", { replace: true });
      } else {
        setAuthMode("login");
        setSignupOpen(true);
      }
    }
  }, [location.pathname, user, loading, navigate]);

  const handleOpenChange = (open) => {
    setSignupOpen(open);
    if (!open && location.pathname === "/login" && !user) {
      navigate("/", { replace: true });
    }
  };


  const openSignup = () => { setAuthMode("signup"); setSignupOpen(true); };
  const openLogin = () => { setAuthMode("login"); setSignupOpen(true); };
  const watchDemo = () => setVideoOpen(true);

  return (
    <div className="relative min-h-screen flex flex-col flex-1 w-full bg-white text-gray-900 overflow-x-hidden" data-testid="landing-page">
      <Navbar onGetStarted={openSignup} onLogin={openLogin} />
      <main className="flex-1 w-full pb-12">
        <Hero onGetStarted={openSignup} onWatchDemo={watchDemo} />
        <TrustedBy />
        <Features />
        <Agents />
        <Workflow />
        <DashboardPreview />
        <Metrics />
        <Testimonials />
        <Pricing />
        <FAQ />
        <Newsletter />
      </main>
      <ChatWidget />
      <SignupDialog open={signupOpen} onOpenChange={handleOpenChange} initialMode={authMode} />
      <VideoModal open={videoOpen} onOpenChange={setVideoOpen} />
    </div>
  );
}
